import {
  detectCountry,
  getCurrentCountry,
  getCurrentTimezone,
  getCountryLabel,
  formatTime,
  formatDate,
  formatDateTime,
  isChina,
  isMexico
} from '../utils/timezoneHelper';

export default {
  install(Vue) {
    Vue.prototype.$detectCountry = detectCountry;
    Vue.prototype.$getCurrentCountry = getCurrentCountry;
    Vue.prototype.$getCurrentTimezone = getCurrentTimezone;
    Vue.prototype.$getTimezone = getCurrentTimezone;
    Vue.prototype.$getCountryLabel = getCountryLabel;
    Vue.prototype.$formatTime = formatTime;
    Vue.prototype.$formatDate = formatDate;
    Vue.prototype.$formatDateTime = formatDateTime;
    Vue.prototype.$isChina = isChina;
    Vue.prototype.$isMexico = isMexico;
    
    Vue.filter('formatTime', formatTime);
    Vue.filter('formatDate', formatDate);
    Vue.filter('formatDateTime', formatDateTime);
  }
};
